import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/5e42c301e259732f49c2ea488f7d916.png'


const _hoisted_1 = { class: "contents" }
const _hoisted_2 = { class: "" }

import Heard from "./heard.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'layout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      class: "bg",
      src: _imports_0
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Heard)
    ]),
    _createVNode(_component_router_view)
  ]))
}
}

})